import { browserHistory } from 'react-router';
import {
  all,
  call,
  delay,
  fork,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { DOCTYPE_BUDGET } from '@krispsystems/constants';

import * as api from '../../services/budget/api_budget';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';

export default function* (app) {
  yield all([
    fork(deleteBudgetSaga, app),
    fork(fetchBudgetForSaga, app),
    fork(fetchListBudgetSaga, app),
    fork(saveBudgetSaga, app),
  ]);
}

function* fetchListBudgetSaga(app) {
  yield takeLatest(
    'FETCH_LIST_BUDGET',
    callFetchListBudget,
    app,
  );
}

function* callFetchListBudget(app, action) {
  const { filters, silent } = action;
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters: {
        ...filters,
        effective_from: filters.dateFrom,
        effective_to: filters.dateTo,
      },
      list_type: 'budget',
    };

    delete dataParams.filters.dateFrom;
    delete dataParams.filters.dateTo;

    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

function* deleteBudget(app, action) {
  try {
    const { id } = action;

    if (!id) return;

    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const state = yield select();
    const { tenant, user } = state;
    const params = { tenant, user, id };
    const result = yield call(api.deleteBudget, app, params);

    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: DOCTYPE_BUDGET },
    });

    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

function* deleteBudgetSaga(app) {
  yield takeEvery(
    'DELETE_BUDGET',
    callDeleteBudget,
    app,
  );
}

function* callDeleteBudget(app, action) {
  const result = yield deleteBudget(app, action);

  yield delay(2000);

  if (result) browserHistory.push('/admin/budget');
}

function* fetchBudgetForSaga(app) {
  yield takeEvery(
    'FETCH_BUDGET',
    callFetchBudget,
    app,
  );
}

function* callFetchBudget(app, action) {
  try {
    const { tenant, user } = yield select();
    const { id, silent } = action;

    if (!id) return;

    yield common.showProgressDataById(silent);

    const fetchParams = { tenant, user, id };
    const doc = yield call(
      api.fetchBudget,
      app,
      fetchParams
    );

    yield common.doneDataById(doc);
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

function* saveBudgetSaga(app) {
  yield takeEvery('SAVE_BUDGET', callSaveBudget, app);
}

function* callSaveBudget(app, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const result = yield call(api.saveBudget, app, {
      tenant,
      user,
      data: action.data,
    });

    const id = result && result.id;

    yield callFetchBudget(app, { id, silent: true });

    browserHistory.push(`/admin/budget/edit/${id}`);

    yield common.doneSaveRecord(result, 'Budget was saved');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
